/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiChatThread, ApiChatTranscript } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ChatThreadsController.
 */
export class ChatThreadsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /chat_threads:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiChatThread>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiChatThread>>>('/chat_threads:query', query);
    }

    /**
     * Calls POST /chat_threads:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiChatThread>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiChatThread>>, ListRequest>('/chat_threads:query', listRequest, query);
    }

    /**
     * Calls GET /chat_threads/{conversationId}/transcript
     */
    public getTranscript(conversationId: string): Promise<Result<ApiChatTranscript>> {
        return this.http.get<Result<ApiChatTranscript>>(`/chat_threads/${conversationId}/transcript`);
    }

    /**
     * Calls GET /chat_threads/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiChatThread>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiChatThread>>(`/chat_threads/${primaryId}`, query);
    }

    /**
     * Calls DELETE /chat_threads/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/chat_threads/${primaryId}`);
    }

    /**
     * Calls POST /chatthreads:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiChatThread>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiChatThread>>, ListRequestWithIds>('/chatthreads:batch', listRequest, query);
    }
}
